export const PASSWORD_MIN_LENGTH = 8;

const PASSWORD_RULE_LABELS = {
  es: {
    minLength: `Mínimo ${PASSWORD_MIN_LENGTH} caracteres`,
    uppercase: "Mínimo 1 mayúscula",
    number: "Mínimo 1 número",
    symbol: "Mínimo 1 símbolo",
    allRules: `La contraseña debe incluir mínimo ${PASSWORD_MIN_LENGTH} caracteres, 1 mayúscula, 1 número y 1 símbolo.`,
  },
  en: {
    minLength: `At least ${PASSWORD_MIN_LENGTH} characters`,
    uppercase: "At least 1 uppercase letter",
    number: "At least 1 number",
    symbol: "At least 1 symbol",
    allRules: `Password must include at least ${PASSWORD_MIN_LENGTH} characters, 1 uppercase letter, 1 number, and 1 symbol.`,
  },
};

export const getPasswordRuleStatuses = (password = "") => ({
  minLength: password.length >= PASSWORD_MIN_LENGTH,
  uppercase: /[A-Z]/.test(password),
  number: /\d/.test(password),
  symbol: /[^A-Za-z0-9\s]/.test(password),
});

export const passwordMeetsAllRules = (password = "") => Object.values(getPasswordRuleStatuses(password)).every(Boolean);

export const getPasswordRuleItems = (language = "es", password = "") => {
  const labels = PASSWORD_RULE_LABELS[language] || PASSWORD_RULE_LABELS.es;
  const statuses = getPasswordRuleStatuses(password);

  return [
    { key: "minLength", label: labels.minLength, satisfied: statuses.minLength },
    { key: "uppercase", label: labels.uppercase, satisfied: statuses.uppercase },
    { key: "number", label: labels.number, satisfied: statuses.number },
    { key: "symbol", label: labels.symbol, satisfied: statuses.symbol },
  ];
};

export const getPasswordPolicyErrorMessage = (language = "es") => {
  const labels = PASSWORD_RULE_LABELS[language] || PASSWORD_RULE_LABELS.es;
  return labels.allRules;
};